module.exports = __webpack_public_path__ + "static/media/box4.d89a1c69.jpeg";